import { CancelError } from '@psl/functions/hooks/useOnPromise';
import { captureException } from '../functions/debugging/crashTracking';

export function onErrorIgnore(error: any): void {
  try {
    if (__DEV__) {
      console.error(error);
    }
    captureException(error);
  } catch {}
}

export function onErrorIgnoreCanceled(error: any): void {
  try {
    if (error instanceof CancelError) {
      return;
    }
    if (__DEV__) {
      console.error(error);
    }
    captureException(error);
  } catch {}
}

export function onErrorAlert(error: any): void {
  try {
    captureException(error);
  } catch {}
  alert((error as Error)?.message ?? 'unknown error');
}
